import customIcons from '../../utils/icons';

interface CollapseButtonProps {
  toggle: () => void;
  isExpanded: boolean;
}

export default function CollapseButton({ toggle, isExpanded }: CollapseButtonProps) {
  return (
    <button
      aria-label="expand-or-collapse-menu-button"
      className="bg-white rounded-full focus:outline focus:outline-blue-600 outline outline-pipgrey-light absolute -right-2 top-10 z-20 shadow-md"
      onClick={toggle}
      type="button"
    >
      <div className="items-center">
        <span className="bg-white hover:cursor-pointer text-primary">{isExpanded ? customIcons.chevronLeft : customIcons.chevronRight}</span>
      </div>
    </button>
  );
}
